<div class="trip-card">
    <ng-content select="[status]"></ng-content>

    <div *ngIf="item['isChoice']" class="choice-label">
        <mat-icon>favorite</mat-icon>
        {{editorChoiceText}}
    </div>

    <div class="detail-operation" *ngIf="itemType!=='tour'&&!item['isOnlineEvent']">
        <mat-icon (click)="showOnMap($event)" matTooltip="locate on map">room</mat-icon>
    </div>

    <div class="card-picture" (click)="viewDetails($event)">
        <!--<img [src]="imageService.safeImage(imageService.imageSourceUrl(item.cover?.source||item.image))" onerror="this.src='https://imgoingcalendar.com/assets/imgs/place-holder.jpg';this.onerror=null" class="image"/>-->
        <ig-image [imageUrl]="item.cover?.source||item.image" [alt]="item.title||item.name"></ig-image>
        <div class="ig-title">
            <p>{{item.title||item.name}}</p>
        </div>
    </div>

    <ig-row class="trip-info-row">
        <ng-container *ngIf="itemType==='event'">
            <ng-container *ngIf="isMultiDateEvent">
                <ig-col [xs]="12" [style.background]="style.tripPlanner.event.color.value">Multiple Dates,
                    {{detailDate}}</ig-col>
            </ng-container>
            <ng-container *ngIf="!isMultiDateEvent">
                <ig-col [xs]="12" [style.background]="style.tripPlanner.event.color.value">
                    <!--<span *ngIf="item.startTimeFormatted">{{item.startTimeFormatted}}{{item.endTimeFormatted?' - '+item.endTimeFormatted:''}}</span>-->
                    <span *ngIf="item.startTimeFormatted">{{item.startTimeFormatted}}</span>
                </ig-col>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="itemType==='tour'">
            <ig-col [xs]="6" class="tour-item-info"
                [style.background]="titleBgColor">{{totalTime?totalTime:'N/A'}}</ig-col>
            <ig-col [xs]="6" class="tour-item-info" [style.background]="titleBgColor">{{totalStop}} STOPS</ig-col>
        </ng-container>

        <div *ngIf="itemType!=='tour'" class="place-card-action-wrap">
            <ng-container *ngIf="featuresToggle.tripPlanner">
                <div details (click)="viewDetails($event)" class="btn-div"
                    [style.background]="style.tripPlanner.place.color.value">see details</div>
                <ig-add-to-trip-menu add *ngIf="!item.isOnlineEvent" [hubName]="hubName" [item]="item"
                    [addToTripText]="'add to trip'"
                    [bgColor]="style.tripPlanner.buttons.color.value"></ig-add-to-trip-menu>
                <div add *ngIf="item.isOnlineEvent" class="ig-blue-btn btn-div"
                    [style.background]="style.tripPlanner.buttons.color.value">Online Event</div>
            </ng-container>
            <ng-container *ngIf="!featuresToggle.tripPlanner">
                <div details (click)="viewDetails($event)" class="btn-div full-width"
                    [style.background]="style.tripPlanner.place.color.value">see details</div>
            </ng-container>
        </div>
    </ig-row>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.card/visitor.trip.card.component.html